import _ from 'lodash';
import React from 'react';
import {PageStore} from '../stores';

export default function(Component) {
  return class withStore extends React.Component {
    static displayName = `withStore(${Component.displayName})`;
    static propTypes = {};
    static defaultProps = {};
    /**
     * @constructor
     * @param {Object} props
     */
    constructor(props) {
      super(props);
      this.state = {
        pageStore: PageStore.getState(),
      };

      _.bindAll(this, 'pageStoreUpdate');
    }
    /**
     * Receive a new pageStore state
     * @param  {Object} pageStore
     */
    pageStoreUpdate(pageStore) {
      this.setState({pageStore});
    }
    /**
     * @override
     */
    componentDidMount() {
      PageStore.listen(this.pageStoreUpdate);
    }

    /**
     * @override
     */
    componentWillUnmount() {
      PageStore.unlisten(this.pageStoreUpdate);
    }

    /**
     * @override
     */
    render() {
      return (
        <Component stores={{page: this.state.pageStore}} {...this.props} />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/hoc/withStore.js